import "core-js/modules/es.function.bind";
import "core-js/modules/web.immediate";
import { __awaiter, __generator } from "tslib";
import Job from './job';

var Queue =
/** @class */
function () {
  function Queue() {
    /** 队列 */
    this.queue = [];
    /** 当前是否正在执行 */

    this.executing = false;
  }

  Queue.prototype.push = function (job) {
    this.queue.push(job);
    this.handle();
  };
  /** cb将获得resolve和reject两个函数 */


  Queue.prototype.promise = function (cb) {
    this.push(Job.promise(cb));
  };

  Queue.prototype.handle = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(!this.executing && this.queue.length > 0)) return [3
            /*break*/
            , 2];
            this.executing = true;
            return [4
            /*yield*/
            , this.queue.shift().execute()];

          case 1:
            _a.sent();

            this.executing = false;
            setImmediate(this.handle.bind(this));
            _a.label = 2;

          case 2:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return Queue;
}();

export default Queue;